module.exports = __webpack_public_path__ + "71adeb04e5eaaae8ccb6e59352c5ef23.png";